/* eslint-disable no-unused-vars */
export enum FormInputTypes {
  INPUT_TEXT = 'text',
  TEXT_AREA = 'textarea',
  NUMBER = 'number',
}
